module.exports = __webpack_public_path__ + "img/test-1-2.35c61b54.jpg";